module.exports = __webpack_public_path__ + "static/media/2 (27).02830aa1.jpg";